import vue from 'vue'
import checkFileDialog from '../Pages/payEgisChat/components/components/common/checkFileDialog'




const checkFileDialogConstrustor =  vue.extend(checkFileDialog);

function showCheckFileDialog(filename,show,md5){
    const toastDom = new checkFileDialogConstrustor({
        el : document.createElement('div'),
        data(){
            return {
                filename:filename,
                show:show,
                md5:md5
            }
        }
    })
　　//在body中动态创建一个div元素，后面自动会把它替换成整个vue文件内的内容
    this.$store.state.dom.appendChild(toastDom.$el)
    console.log(this.$store.state.dom)
    // this.$store.dispatch("showBlackmask");
}

function registryCFD (){
    //把showToast这个方法添加到vue的原型中，可以直接调用，当调用的时候就是执行函数内的内容
    vue.prototype.$CheckFileDialog = showCheckFileDialog
}

export default registryCFD